import { Action } from '@ngrx/store';
import {
  AddSearchPayload, RemoveSearchPayload, AddQuickscanSearchPayload, RemoveQuickscanSearchPayload, SetNlpPayload, RemoveNlpPayload,
  SetQuickscanNlpPayload, RemoveQuickscanNlpPayload
} from 'store/models/pusher.models';

/**
 * For each action type in an action group, make a simple
 * enum object for all of this group's action types.
 */
export enum PusherActionTypes {
  SET_SCREENING = 'SET_SCREENING',
  REMOVE_CUSTOMER = 'REMOVE_CUSTOMER',
  CLEAR_CUSTOMER = 'CLEAR_CUSTOMER',
  REMOVE_SCREENING = 'REMOVE_SCREENING',
  SET_QUICKSCAN_SEARCH = 'SET_QUICKSCAN_SEARCH',
  REMOVE_QUICKSCAN_SEARCH = 'REMOVE_QUICKSCAN_SEARCH',
  REMOVE_QUICKSCAN = 'REMOVE_QUICKSCAN',
  SET_NLP = 'SET_NLP',
  REMOVE_NLP = 'REMOVE_NLP',
  SET_QUICKSCAN_NLP = 'SET_QUICKSCAN_NLP',
  REMOVE_QUICKSCAN_NLP = 'REMOVE_QUICKSCAN_NLP'
}

export type PusherActions
  = SetScreening
  | RemoveCustomer
  | ClearCustomer
  | RemoveScreening
  | RemoveQuickscanSearch
  | SetQuickscanSearch
  | RemoveQuickscan
  | SetNlp
  | RemoveNlp
  | SetQuickscanNlp
  | RemoveQuickscanNlp;

export class SetScreening implements Action {
  readonly type: PusherActionTypes = PusherActionTypes.SET_SCREENING;
  constructor(public payload: AddSearchPayload = null) { }
}

export class RemoveScreening implements Action {
  readonly type: PusherActionTypes = PusherActionTypes.REMOVE_SCREENING;
  constructor(public payload: RemoveSearchPayload = null) { }
}

export class RemoveCustomer implements Action {
  readonly type: PusherActionTypes = PusherActionTypes.REMOVE_CUSTOMER;
  constructor(public payload: number[] = null) { }
}

export class ClearCustomer implements Action {
  readonly type: PusherActionTypes = PusherActionTypes.CLEAR_CUSTOMER;
  constructor(public payload: number[] = null) { }
}

export class SetQuickscanSearch implements Action {
  readonly type: PusherActionTypes = PusherActionTypes.SET_QUICKSCAN_SEARCH;
  constructor(public payload: AddQuickscanSearchPayload = null) { }
}

export class RemoveQuickscanSearch implements Action {
  readonly type: PusherActionTypes = PusherActionTypes.REMOVE_QUICKSCAN_SEARCH;
  constructor(public payload: RemoveQuickscanSearchPayload = null) { }
}

export class RemoveQuickscan implements Action {
  readonly type: PusherActionTypes = PusherActionTypes.REMOVE_QUICKSCAN;
  constructor(public payload: string[] = null) { }
}

export class SetNlp implements Action {
  readonly type: PusherActionTypes = PusherActionTypes.SET_NLP;
  constructor(public payload: SetNlpPayload = null) { }
}

export class RemoveNlp implements Action {
  readonly type: PusherActionTypes = PusherActionTypes.REMOVE_NLP;
  constructor(public payload: RemoveNlpPayload = null) { }
}

export class SetQuickscanNlp implements Action {
  readonly type: PusherActionTypes = PusherActionTypes.SET_QUICKSCAN_NLP;
  constructor(public payload: SetQuickscanNlpPayload = null) { }
}

export class RemoveQuickscanNlp implements Action {
  readonly type: PusherActionTypes = PusherActionTypes.REMOVE_QUICKSCAN_NLP;
  constructor(public payload: RemoveQuickscanNlpPayload = null) { }
}
